/*
 * @desc app config
 *  活动后台配置活动id 正式环境 4763
 */
import { getRegion } from './util'
// prod/preprod/test/dev
const ENV = 'prod'
// VERSION_CODE规则两位数字表示VERSION_NAME的一个数据。eg:VERSION_NAME = '9.9.99' VERSION_CODE=90999
const VERSION_NAME = '1.0.0'
const VERSION_CODE = 10000

const getUrl = (region) => {
  if (!['IN', 'CN', 'ID', 'VN', 'TH', 'PH', 'MY', 'TW'].includes(region)) {
    region = 'in'
  }
  region = region.toLowerCase()
  return {
    dev: {
      // set proxy in vue.config.js
      baseUrl: '',
    },
    test: {
      baseUrl: `http://${region === 'cn' ? 'in' : region}.instantgame-oversea-test-cloud.wanyol.com`,
    },
    prod: {
      baseUrl: `https://api-${region === 'cn' ? 'in' : region}.play.heytapmobile.com`,
    },
  }
}

export const getCoimMallUrl = () => {
  if (ENV === 'prod') {
    return 'https://actimg.heytapimg.com/cdo-activity/4617/200ef80e7f2c59be218ec074eb346b1b.html?actId=4617&region=IN&c=0'
  } else {
    return 'https://actimg.heytapimg.com/cdo-activity/202012/04/dist72/htmls/1fd05ee22cbf49f4be0e350289b8b25f.html?actId=4617&region=IN&c=0#/'
  }
}
// the config to export
const CONFIG = { urlMap: null, env: ENV, versionCdoe: VERSION_CODE, versionName: VERSION_NAME }
let hasLoggedInfo = false
export const getConfig = () => {
  if (!CONFIG.urlMap) {
    let region = getRegion()
    console.log(region)
    // cancel set default urlmap to avoid local law
    CONFIG.urlMap = getUrl(region)[ENV]
  }
  if (!hasLoggedInfo) {
    console.log(`config//${JSON.stringify(CONFIG)}`)
    hasLoggedInfo = true
  }
  return CONFIG
}

export const configInfo = { env: ENV }


// WEBPACK FOOTER //
// ./src/utils/config.js